export const parseCustomAttribute = (attr) => {
  try {
    return JSON.parse(attr);
  } catch {
    return [];
  }
};
